import React, { useEffect } from 'react';
import { usePaymentForm } from './hooks/PaymentForm.hook';
import PaymentFormView from './views/PaymentFormView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const PaymentFormController = (props) => {
  const { spaceDetail, formValues } = props;
  const {
    isLoading,
    stripePromise,
    getSripeOptions,
    getTotalPrice,
    errorMessage,
    isLoadingCheckout,
    submitPaymentForm,
  } = usePaymentForm(spaceDetail, formValues);
  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <PaymentFormView
        spaceDetail={spaceDetail}
        formValues={formValues}
        stripePromise={stripePromise}
        getSripeOptions={getSripeOptions}
        getTotalPrice={getTotalPrice}
        errorMessage={errorMessage}
        isLoadingCheckout={isLoadingCheckout}
        submitPaymentForm={submitPaymentForm}
      />
    );
  }
};

export default PaymentFormController;
